import { render, staticRenderFns } from "./ConfirmationSummaryContactRow.vue?vue&type=template&id=94a8c2e2&scoped=true&"
import script from "./ConfirmationSummaryContactRow.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSummaryContactRow.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationSummaryContactRow.vue?vue&type=style&index=0&id=94a8c2e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a8c2e2",
  null
  
)

export default component.exports